<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">
                    {{ $t('update_chequecard_transaction') }}
                </h1> 
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item text-primary">{{ $t('transactions') }}</li>
                    <li class="breadcrumb-item text-gray-600">{{ $t('update_chequecard_transaction') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li>
                </ul>
            </div>
            <div class="d-flex align-items-center py-1" v-if="getSubCredentials('R')">
                <button type="button" class="btn btn-light border border-gray-400" data-bs-toggle="modal" data-bs-target="#kt_modal_transaction_list" @click="onOpenTransactionListModal()" :disabled="!this.$getUser().is_allow_list_all_data && (this.form.payment_account_id == null || this.form.payment_account_id == undefined || this.form.payment_account_id == '-1')" >
                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                    </svg>
                    </span>
                    {{ $t('transaction_list') }}
                </button>
            </div>
        </div>  
        <div class="content flex-row-fluid mt-2" id="kt_content">  
        <!-- <StatsBar></StatsBar> -->
        <RequiredField></RequiredField>
        <div class="card card-xxl-stretch">
          <div class="row p-4">
            <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div class="row p-4">
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                            <div class="card-header">
                                <div class="card-title">
                                    <h3>{{ $t('chequecard_transaction') }}</h3>
                                </div>
                                <div class="d-flex justify-content-end py-4 -">
                                    &nbsp;
                                    <router-link to="/ChequeTransactionCreate" v-if="getSubCredentials('I')">
                                            <button type="button" class="btn btn-light-primary border border-primary me-3">
                                                <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                                                    <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor"/>
                                                    <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor"/>
                                                </svg>
                                                </span>
                                                {{ $t('start_new_chequecard_transaction') }}
                                            </button>
                                    </router-link> 
                                    <div class="dropdown">
                                        <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="chequeActions" type="button">
                                        <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                                        <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                                        </svg></span>
                                            {{ $t('actions') }}
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="chequeActions"> 
                                            <li v-if="form.is_accounted == 1 && this.$getUser().is_allow_cancel_accounting_integration"><a class="dropdown-item fs-4 text-danger" href="#" @click="onCancelIntegration()">{{ $t('cancel_accounting_integration') }}</a></li>
                                            <li v-if="getSubCredentials('D')"><a class="dropdown-item fs-4 text-danger" href="#" @click="deleteChequeHeader()">{{ $t('delete') }} </a></li>
                                        </ul> 
                                    </div>
                                    <div class="dropdown ms-3" v-if="getSubCredentials('P')">
                                        <button class="btn btn-light-warning border border-warning dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="chequePrintActions" type="button">
                                            <i class="fa fa-print"></i>
                                            {{ $t('print_actions') }}
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="chequePrintActions"> 
                                            <li>
                                                <a class="dropdown-item fs-4 text-primary py-4" href="#" @click="printReceipt()" 
                                                    data-bs-toggle="modal" data-bs-target="#kt_modal_print">
                                                    <i class="fa fa-print text-primary fs-5"></i>  {{ $t('print_receipt') }}
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item fs-4 text-primary py-4" href="#" @click="downloadReceipt()">
                                                    <i class="fa fa-file text-primary fs-5"></i> {{ $t('download_pdf') }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>  
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="fv-row row">
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label" v-tag="'record_date'">
                                            {{ $t('record_date') }}
                                        </label>
                                        <Datepicker :locale="$datepickerLocale()"  name="record_date" v-custom :required="this.$checkIfDateFieldRequired ('record_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.record_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false" :disabled="this.chequeItemsList.length > 0"/>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label" v-tag="'record_type'">
                                            {{ $t('record_type') }}
                                        </label>
                                        <Select2 name="record_type" v-custom v-model="form.record_type" :options="recordTypeList" :settings="{ width: '100%' }" :disabled="this.chequeItemsList.length > 0" />
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label" v-tag="'transaction_type'">
                                            {{ $t('transaction_type') }}
                                        </label>
                                        <Select2 name="transaction_type" v-custom v-model="form.transaction_type" :options="transactionTypeFilteredList" :settings="{ width: '100%' }"
                                        @select="onChangeTransactionType()" disabled />
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label" v-tag="'payment_account_id'">
                                            {{ $t('select_payment_account') }}
                                        </label>
                                        <div class="input-group">
                                            <button type="button" class="btn rounded-start-0 btn-light btn-icon text-hover-primary border border-1 border-gray-300" data-bs-toggle="modal" data-bs-target="#kt_modal_account_report_selection" @click="onOpenAccountReport()"
                                                v-if="form.payment_account_id !== null && form.payment_account_id !== '-1' && form.payment_account_id !== '' && form.payment_account_id !== undefined">
                                                <i class="fa fa-eye text-gray-600 fs-3"></i>
                                            </button>
                                            <input type="search" class="form-control form-control-lg" name="payment_account_name" v-model="form.payment_account_name" v-custom @input="form.payment_account_id = null" :placeholder="$t('please_type_an_account')" :disabled="chequeItemsList.length > 0">
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 mt-0">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300 mb-10">
                            <div class="card-body pb-0">
                                <div class="p-0">
                                    <div class="d-flex flex-stack flex-wrap mb-2">
                                        <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                                            <button type="button" class="btn btn-sm btn-success fw-bold required me-3"
                                                data-bs-toggle="modal"
                                                :disabled="form.payment_account_id == null || form.payment_account_id == '' || form.payment_account_id == '-1' || form.payment_account_id == undefined"
                                                data-bs-target="#kt_modal_add_item" 
                                                @click="openItemModal('addItem')"
                                                data-kt-menu-trigger="click" 
                                                data-kt-menu-placement="bottom-end">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                                            transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                        <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                                            fill="currentColor">
                                                        </rect>
                                                    </svg>
                                                </span> 
                                                {{ $t('add_new') }}
                                            </button>
                                            <button type="button" class="btn btn-sm btn-light btn-active-primary me-3" 
                                                data-bs-toggle="modal"
                                                data-bs-target="#kt_modal_add_item" 
                                                @click="openItemModal('editItem')"
                                                :disabled="isItemButtonDisabled == null || isItemButtonDisabled == undefined">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                                    </svg>
                                                </span> 
                                                {{ $t('edit') }}
                                            </button>
                                            <button type="button" class="btn btn-sm btn-light btn-active-warning me-3"
                                                @click="deleteChequeItem()"
                                                :disabled="isItemButtonDisabled == null || isItemButtonDisabled == undefined">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                    </svg>
                                                </span>
                                                {{ $t('remove') }}
                                            </button>
                                            <button type="button" class="btn btn-sm btn btn-light btn-active-danger" @click="deleteAllChequeItems()">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                    </svg>
                                                </span>
                                                {{ $t('remove_all') }}
                                            </button> 
                                        </div>
                                        <div class="flex-row">
                                            <div class="d-flex justify-content-end">
                                                <span class="fw-bold text-gray-600 me-5">{{ $t('docket_number') }}: </span>
                                                <span class="fw-boldest text-black-600"> {{this.form.docket_number}} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pb-10">
                                        <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                                                :show-borders="true" 
                                                key-expr="id" 
                                                :data-source="chequeItemsList" 
                                                :allow-column-reordering="true"  
                                                :allow-column-resizing="true" 
                                                :column-auto-width="true" 
                                                :row-alternatin-enabled="true"
                                                :hover-state-enabled="true" 
                                                :show-row-lines="true"
                                                :customize-columns="onCustomizeColumn"
                                                @exporting="this.$onExporting($event , 'Cheque-transaction-items')"
                                                :scrolling="{ mode: 'virtual' }"
                                                @option-changed="handlePropertyChange"> 

                                                <DxFilterRow :visible="true"/>
                                                <DxHeaderFilter :visible="true"/>
                                                <DxGroupPanel :visible="true"/>      
                                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                <DxPaging :page-size="10"/>
                                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                                                <DxSearchPanel :visible="true"/> 
                                               
                                                <DxColumn data-field="isSelected" caption="#" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-exporting="false"/> 
                                                <DxColumn data-field="id" caption="" alignment="right" cell-template="id-cell-template" :allow-exporting="false"/> 
                                                <DxColumn data-field="due_date" :caption="$t('due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" cell-template="due_date-cell-template"/>  
                                                <DxColumn v-if="form.record_type == 1" data-field="item_type_name" :caption="$t('type')" cell-template="item_type_name-cell-template"/>   
                                                <DxColumn v-if="form.record_type == 2" data-field="card_item_type_name" :caption="$t('type')" cell-template="card_item_type_name-cell-template"/>   
                                                <DxColumn data-field="payment_account_name" :caption="$t('payment_account')" header-cell-template="payment-account-header" cell-template="payment_account_name-cell-template"/>   
                                                <DxColumn data-field="bank_account_name" :caption="$t('bank_account')" header-cell-template="bank-account-header" cell-template="cash_bank_account_name-cell-template"/>   
                                                <DxColumn data-field="transaction_number" :caption="$t('transaction_no')" header-cell-template="transaction-no-header" cell-template="transaction_number-cell-template"/>
                                                <DxColumn data-field="cheque_number" :caption="$t('cheque')/$t('card_no')" header-cell-template="cheque-no-header" cell-template="cheque_number-cell-template"/>
                                                <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right" cell-template="amount-cell-template"/>  
                                                <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/>  
                                                <DxColumn data-field="rate" :caption="$t('rate')" :sorting-method="this.$numericSort" alignment="right" cell-template="rate-cell-template"/> 
                                                <DxColumn data-field="amount_local" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" header-cell-template="local-amount-header" cell-template="amount_local-cell-template"/> 
                                                <DxColumn data-field="transaction_date" :caption="$t('date')" data-type="date" alignment="right" format="dd.MM.yyyy" cell-template="transaction_date-cell-template"/> 
                                                <DxColumn data-field="last_position_name" :caption="$t('last_position')" alignment="right" cell-template="last_position_name-cell-template" header-cell-template="last-position-header" /> 

                                                <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                                                <template #headerLocalTemplate="{ data: data }">
                                                    <div v-html="setColumnTemplateForLocal(data)"></div> 
                                                </template>
                                                <!-- <DxColumn data-field= 09.09.2022 caption="Value Date" alignment="right"/>  -->

                                                <template #bank-account-header>
                                                    <div>{{ $t('bank_account') }}</div>
                                                </template>
                                                <template #payment-account-header>
                                                    <div>{{ $t('payment_account') }}</div>
                                                </template>
                                                <template #transaction-no-header>
                                                    <div>{{ $t('transaction_no') }}</div>
                                                </template>
                                                <template #cheque-no-header>
                                                    <div>{{ $t('cheque_no') }}/</div><div>{{ $t('card_no') }}</div>
                                                </template>
                                                <template #local-amount-header>
                                                    <div>{{ $t('local_amount') }}</div>
                                                </template>
                                                <template #last-position-header>
                                                    <div>{{ $t('last_position') }}</div>
                                                </template>

                                                <template #is-selected-cell-template="{ data }">
                                                    <span>
                                                        <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center" v-if="data.data.id !== null && data.data.id !== ''">
                                                            <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectItem(data.data)" />
                                                        </div>
                                                    </span>
                                                </template>
                                                <template #id-cell-template="{ data }">
                                                    <a href="#" class="text-gray-800 text-hover-primary">
                                                        {{ (this.pageSize * this.pageIndex) + data.rowIndex + 1 }}
                                                    </a>
                                                </template>
                                                <template #due_date-cell-template="{ data }">
                                                      <span class="text-gray-700 p-3 align-middle text-end" > {{ previewDate(data.data.due_date) }}</span>
                                                </template>
                                                <template #item_type_name-cell-template="{ data }">
                                                    <span class="fw-bold p-3 align-middle" :class="{ 'text-primary': data.data.item_type == 1 , 'text-danger': data.data.item_type == 2}"> {{ data.data.item_type_name }}</span>
                                                </template>
                                                <template #card_item_type_name-cell-template="{ data }">
                                                    <span class="fw-bold p-3 align-middle" :class="{ 'text-primary': data.data.item_type == 1 , 'text-danger': data.data.item_type == 2}"> {{ data.data.card_item_type_name }}</span>
                                                </template>
                                                <template #cash_bank_account_name-cell-template="{ data }">
                                                      <span class="text-gray-700 p-3 align-middle" > {{ data.data.bank_account_name }}</span>
                                                </template>
                                                <template #payment_account_name-cell-template="{ data }">
                                                      <span class="text-gray-700 p-3 align-middle" >{{ data.data.payment_account_name }}</span>
                                                </template>
                                                <template #transaction_number-cell-template="{ data }">
                                                      <span class="text-gray-600 p-3 align-middle" >{{ data.data.transaction_number }}</span>
                                                </template>
                                                <template #cheque_number-cell-template="{ data }">
                                                      <span class="text-gray-600 p-3 align-middle" >{{ data.data.cheque_number }}</span>
                                                </template>
                                                <template #amount-cell-template="{ data }">
                                                      <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount}}</span>
                                                </template>
                                                <template #currency-cell-template="{ data }">
                                                      <span class="text-gray-800 fw-bold p-3 align-middle"> {{data.data.currency}}</span>
                                                </template>
                                                <template #rate-cell-template="{ data }">
                                                      <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.rate}} </span>
                                                </template>
                                                <template #amount_local-cell-template="{ data }">
                                                      <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount_local}} </span>
                                                </template>
                                                <template #transaction_date-cell-template="{ data }">
                                                      <span class="text-gray-700 p-3 align-middle text-end" > {{ previewDate(data.data.transaction_date) }}</span>
                                                </template> 
                                                <template #last_position_name-cell-template="{ data }">
                                                      <span class="text-gray-700 p-3 align-middle text-end" > {{ data.data.last_position_name }}</span>
                                                </template> 
                                                <DxSummary :calculate-custom-summary="setSummaries">
                                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="isSelected"/>
                                                    <DxGroupItem
                                                        :show-in-group-footer="true"
                                                        name="amount_local"
                                                        summary-type="custom"
                                                        show-in-column="amount_local"
                                                        display-format="{0}"
                                                    /> 
                                                    <DxTotalItem name="amount_local"
                                                        summary-type="custom"
                                                        show-in-column="amount_local"
                                                    />
                                                </DxSummary>
                                        </DxDataGrid>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="row g-xxl-5">
                            <div class="col-lg-12" v-if="this.chequeItemsList.length > 0">
                                <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                    <!-- <div class="card-header">
                                        <div class="card-title">
                                            <h3 class="text-gray-800 me-5"> Docket Total </h3>
                                        </div>
                                    </div> -->
                                    <div class="card-body p-3">
                                        <div class="d-flex align-items-center flex-wrap d-grid gap-2">
                                            <div class="d-flex align-items-center me-5 me-xl-13">
                                                <div class="symbol symbol-30px symbol-circle me-3">
                                                    <span class="symbol-label bg-light-primary border border-gray-300">
                                                    <i class="bi bi-hourglass-split fs-3"></i>
                                                    </span>                
                                                </div>
                                                <div class="m-0">                            
                                                    <span class="fw-semibold text-gray-500 d-block fs-8">{{ $t('average_due_state') }}</span>
                                                    <span class="fw-bold text-gray-800 text-hover-primary fs-7"> {{this.dueSummary.total_average_due_state}} </span>
                                                </div>
                                            </div>                 
                                            <div class="d-flex align-items-center">
                                                <div class="symbol symbol-30px symbol-circle me-3">
                                                    <span class="symbol-label bg-light-info border border-gray-300">
                                                        <i class="bi bi-calendar-check fs-3"></i>
                                                    </span>                
                                                </div>
                                                <div class="m-0">                            
                                                    <span class="fw-semibold text-gray-500 d-block fs-8">{{ $t('average_due_state') }}</span>
                                                    <span class="fw-bold text-gray-800 text-hover-primary fs-7"> {{previewDate(this.dueSummary.total_average_due_date)}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12" v-if="getSubCredentials('U')">
                                <div class="d-grid gap-2"> 
                                    <button class="btn btn-primary btn-lg mb-0" type="submit" @click="updateChequeHeader()" data-kt-indicator="on"  :disabled="chequeItemsList.length == 0"> 
                                        <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        </svg>
                                        </span>
                                        <strong v-if="!this.isDocketSaving"> {{ $t('update_transaction') }} </strong> 
                                        <span class="indicator-progress" v-if="this.isDocketSaving">
                                            {{ $t('saving-transaction-please-wait') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
          </div>
        </div>
        </div>
        <!-- ADD TRANSACTION MODAL -->
        <div class="modal fade" id="kt_modal_add_item" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" :class="{'modal-xxl': this.activeTab == 'BalanceClosing'}">
                <div class="modal-content"  >
                    <div class="modal-header bg-primary" id="kt_modal_add_user_header">                        
                        <h2 class="modal-title fw-bolder col-md-11 text-white">
                            <span v-if="this.modalType == 'addItem'"> {{ $t('add') }} </span>
                            <span v-if="this.modalType == 'editItem'"> {{$t('edit')}} </span> {{ $t('transaction') }}
                        </h2>
                        <div class="btn btn-icon btn-sm btn-active-icon-primary"
                            data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body scroll-y" :class="{'overlay overlay-block': this.isDocketItemSaving == true}">
                        <ul class="nav nav-tabs nav-line-tabs mb-5 fs-6">
                            <li class="nav-item">
                                <a class="nav-link cursor-pointer" :class="{'active': this.activeTab == 'Transaction'}" @click="this.activeTab = 'Transaction'"><h4>{{ $t('transaction') }}</h4></a>
                            </li> 
                            <li class="nav-item" v-if="this.$isCredentialActive(26,'') && (form.payment_account_type == 1 || form.payment_account_type == 2)">
                                <a class="nav-link cursor-pointer" :class="{'active': this.activeTab == 'BalanceClosing'}" 
                                    @click="this.activeTab = 'BalanceClosing', onClickBalanceClosing();">
                                    <h4>{{ $t('balance_closing') }}</h4>
                                </a>
                            </li> 
                            <li class="nav-item" v-if="this.$isModuleActive(3)">
                                <a class="nav-link cursor-pointer" :class="{'active': this.activeTab == 'Document'}" @click="this.onActivateDocumentsTab()"><h4>{{ $t('documents') }}</h4></a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade" :class="{'show active': this.activeTab == 'Transaction'}">
                                <RequiredFieldOnModal :routeName="this.modalType == 'addItem' ? 'ChequeTransactionItemCreate' : 'ChequeTransactionItemUpdate'" class="mt-5"></RequiredFieldOnModal>
                                <form id="chequeItemForm" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="card card-xxl-stretch mb-6">
                                                        <div class="card-body p-5">
                                                            <div class="row mb-2" v-if="this.form.transaction_type == 1">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6 " v-tag="'bank_account_id'" >
                                                                    {{ $t('select_bank') }}
                                                                </label>                                                            
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <Select2 v-model="chequeForm.bank_account_id" :options="bankList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content' }" :disabled="modalType == 'editItem'" name="bank_account_id" v-custom />
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2" v-if="this.form.transaction_type == 2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6 " v-tag="'bank_account_id'">
                                                                    {{ $t('select_chequecard_account') }}
                                                                </label>                                                            
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <Select2 v-model="chequeForm.bank_account_id" :options="bankAccountList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content' }" @select="onChangeChequeAccount()" :disabled="modalType == 'editItem'" name="bank_account_id" v-custom/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="card card-xxl-stretch mb-6">
                                                        <div class="card-body p-5"> 
                                                            <div class="row mb-2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6 ">
                                                                    <span v-tag="'transaction_date'" >{{ $t('transaction') }}</span>
                                                                    <span v-tag="'due_date'" > / {{ $t('due_date') }}</span>
                                                                </label>
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <div class="row">
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                                            <Datepicker :locale="$datepickerLocale()"  :required="this.$checkIfDateFieldRequired('transaction_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="chequeForm.transaction_date"  format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false"  @update:modelValue="onChangeCurrency()" :disabled="modalType == 'editItem'" name="transaction_date" v-custom />
                                                                        </div> 
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                                            <Datepicker :locale="$datepickerLocale()"  :required="this.$checkIfDateFieldRequired('due_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="chequeForm.due_date"  format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false" :disabled="modalType == 'editItem'" name="due_date" v-custom />                                                                    
                                                                        </div>                                                                
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6 ">
                                                                    <span v-tag="'currency'" > {{ $t('currency') }} </span> 
                                                                    <span v-tag="'rate'" v-if="this.chequeForm.currency !== this.localCurrency"> / {{ $t('rate') }} </span>
                                                                </label>
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <div class="row">
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container" :class="{ 'col-lg-12': this.chequeForm.currency == this.localCurrency }">
                                                                            <Select2 v-model="this.chequeForm.currency" :options="this.currencyList" @select="onChangeCurrency()" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content' }" :disabled="this.form.transaction_type == 2 || modalType == 'editItem'" name="currency" v-custom />
                                                                        </div>
                                                                        <div class="col-lg-6 fv-row fv-row fv-plugins-icon-container" v-if="this.chequeForm.currency !== this.localCurrency">
                                                                            <Select2 v-model="typeSelection" :options="typeList" @select="onChangeRateType()" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content' }" :disabled="modalType == 'editItem'"/>  
                                                                        </div>
                                                                        <div class="col-lg-12 fv-row fv-plugins-icon-container mt-3" v-if="this.chequeForm.currency !== this.localCurrency">
                                                                            <CurrencyInput type="text" class="form-control" v-model="this.chequeForm.rate" :precision="5" @focus="$event.target.select()"  @blur="calculateLocalAmount()" :disabled="modalType == 'editItem'" name="rate" v-custom />
                                                                            <small v-if="this.chequeForm.rate_date !== null">{{ $t('rate_date') }}: {{ previewDate(this.chequeForm.rate_date) }}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6 ">
                                                                    <span v-tag="'amount'" > {{ $t('amount') }} </span> 
                                                                    <span v-if="this.chequeForm.currency !== this.localCurrency">/ {{ $t('local_amount') }} </span>
                                                                </label>
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <div class="row">
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container" :class="{ 'col-lg-12': this.chequeForm.currency == this.localCurrency }">
                                                                            <div class="input-group mb-3">
                                                                                <CurrencyInput type="text" class="form-control text-end" v-model="chequeForm.amount" @focus="$event.target.select()" @blur="calculateLocalAmount()" :disabled="modalType == 'editItem'" name="amount" v-custom />
                                                                                <ErrorMessage name="amount" class="text-danger" />
                                                                                <span class="input-group-text p-1">
                                                                                    <button type="button" class="btn btn-light btn-sm p-1" @click="this.onChangeAmount()" :disabled="modalType == 'editItem'">
                                                                                        <i class="bi bi-box-arrow-in-down-left fs-2"></i>
                                                                                    </button>
                                                                                </span>
                                                                            </div>  
                                                                        </div>
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container" v-if="this.chequeForm.currency !== this.localCurrency">
                                                                            <div class="input-group mb-3">
                                                                                <CurrencyInput type="text" name="amount_local" class="form-control text-end" v-model="chequeForm.amount_local" @focus="$event.target.select()" @blur="calculateAmountLocal()"  :disabled="this.isLocalAmountDisabled ||  this.chequeForm.amount <= 0 || this.chequeForm.amount == 0.00"/>
                                                                                <ErrorMessage name="amount" class="text-danger" />   
                                                                                <span class="input-group-text p-1">
                                                                                    <button type="button" class="btn btn-light btn-sm p-1" @click="this.onChangeAmountLocal()" :disabled="modalType == 'editItem' || this.chequeForm.amount <= 0 || this.chequeForm.amount == 0.00">
                                                                                        <i class="bi bi-pencil-square fs-6"></i>
                                                                                    </button>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                                    <span v-tag="'transaction_number'" >{{ $t('transaction_no') }}</span>
                                                                    <span v-tag="'cheque_number'" v-if="form.record_type == 1"> / {{ $t('cheque_no') }}</span>
                                                                    <span v-tag="'cheque_number'" v-if="form.record_type == 2"> / {{ $t('card_no') }}</span>
                                                                </label>
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <div class="row">
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                                            <input type="text" class="form-control fw-boldest text-black-600" v-model="chequeForm.transaction_number" :disabled="modalType == 'editItem'" name="transaction_number" v-custom >
                                                                        </div>
                                                                        <div class="col-lg-6 fv-row fv-plugins-icon-container">
                                                                            <input v-if="form.record_type == 1" type="text" class="form-control" v-model="chequeForm.cheque_number" :disabled="modalType == 'editItem'" name="cheque_number" v-custom >
                                                                            <input v-if="form.record_type == 2" type="text" class="form-control" v-maska="'####-####-####-####'" v-model="chequeForm.cheque_number" :disabled="modalType == 'editItem'" name="cheque_number" v-custom >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mb-2">
                                                                <label class="col-lg-4 col-form-label fw-bold fs-6" v-tag="'description'" >
                                                                    <span>{{ $t('description') }}</span>
                                                                </label>
                                                                <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                                                    <div class="input-group">
                                                                        <input type="text" class="form-control" v-model="chequeForm.description" :disabled="modalType == 'editItem'" name="description" v-custom >
                                                                        <div class="input-group-append" v-if="this.descriptionTypeList.length > 0">
                                                                            <div class="dropdown dropup">
                                                                                <button class="btn btn-secondary border border-gray-300 dropdown-toggle rounded-start-0" type="button" @click="this.isOpenDescriptionDropdown = !this.isOpenDescriptionDropdown;" :disabled="modalType == 'editItem'">
                                                                                    <i class="bi bi-plus-lg fs-5 fw-boldest"> </i>
                                                                                </button>
                                                                                <div class="dropdown-menu px-3 dropdown-menu-end" data-bs-popper="true" :class="{ 'show': this.isOpenDescriptionDropdown }">
                                                                                    <ul class="mh-250px mb-0 overflow-scroll list-unstyled"> 
                                                                                        <li v-for="(item, index) in descriptionTypeList" v-bind:key="item">
                                                                                            <a class="dropdown-item cursor-pointer p-2 mw-500px" @click="onSelectDescription(item)" :disabled="modalType == 'editItem'"
                                                                                                :class="{'text-success': this.chequeForm.description == item.description && item.description !== ''}">
                                                                                                <i class="bi bi-dash fw-boldest" v-if="this.chequeForm.description !== item.description"> </i> 
                                                                                                <i class="bi bi-check-lg fw-boldest text-success" v-if="this.chequeForm.description == item.description && item.description !== ''"> </i>
                                                                                                {{item.text}}  
                                                                                            </a>
                                                                                            <div class="separator separator-dashed my-1" v-if="index !== descriptionTypeList.length - 1"></div>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card">
                                            <div class="d-grid gap-2"> 
                                                <button type="button" class="btn btn-success btn-lg" v-if="this.modalType == 'addItem'"
                                                    @click="this.addChequeItem()" :disabled="this.isModalButtonDisabled">
                                                    <strong>{{ $t('add_to_list') }}</strong> 
                                                </button>
                                                <button type="button" class="btn btn-primary btn-lg" v-if="this.modalType == 'editItem'"
                                                    @click="this.editChequeItem()" :disabled="this.isModalButtonDisabled">
                                                    <strong>{{ $t('update') }}</strong> 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="tab-pane fade" :class="{'show active': this.activeTab == 'BalanceClosing'}">
                                <BalanceClosingList ref="BalanceClosingList" :modal-type="this.modalType" :active-tab="this.activeTab"></BalanceClosingList>
                            </div>
                            <div class="tab-pane fade" :class="{'show active': this.activeTab == 'Document'}">
                                <div class="row" v-if="this.activeTab == 'Document'">
                                    <FileManager :location="2" 
                                        :locationtype="5" 
                                        :is_transaction="1" 
                                        :account_a="this.chequeForm.bank_account_id" 
                                        :account_b="this.form.payment_account_id" 
                                        :uuid="this.fileUUID"
                                        :upload_source="1">
                                    </FileManager>
                                </div> 
                            </div>
                        </div>
                        <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isDocketItemSaving == true">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">{{ $t('loading') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="modal fade" id="kt_modal_print" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
			<PrintModal ref="PrintModal" />
		</div> 

        <!-- Transaction List -->
        <div class="modal fade" id="kt_modal_transaction_list" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <TransactionListModal ref="TransactionListModal" :transaction-type="6" :account-id="this.form.payment_account_id" :account-name="form.payment_account_name"/>
        </div>

        <!-- Statement Modal  -->
        <div class="modal fade" id="kt_modal_account_report_selection" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <AccountReports ref="AccountReports" :account-name="form.payment_account_name" :account-id="form.payment_account_id" :account-type="form.payment_account_type" />
        </div>
    </div>
</template>

<script>
import axios from "axios";

import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxGroupItem   } from 'devextreme-vue/data-grid';
import { uuid } from 'vue3-uuid';
import PrintModal from '../Modals/PrintModal.vue';
import { saveAs } from 'file-saver';
import TransactionListModal from '../TransactionListModal.vue';
import BalanceClosingList from '../Modals/BalanceClosingList.vue';
 
export default {
  name: "ChequeTransactionUpdate",
  components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxGroupItem, PrintModal, TransactionListModal, BalanceClosingList
  },
  data() {
    return {
        userData: this.$getUser(),
        pageSize: null,
        pageIndex: 0,
        fileUUID: null,
        activeTab: 'Transaction',
        isOpenDescriptionDropdown: false,
        isPrintModalOpen: false,
        searchbar: '',
        chequeItemsList: [],
        currencyList: [],
        transactionList: [],
        bankAccountList: [{ id: '-1', text: this.$t('select_an_option')}],
        transactionTypeList: [
            { id: 1, text: this.$t('incoming_cheque'), type: 1},
            { id: 2, text: this.$t('outgoing_cheque'), type: 1},
            { id: 1, text: this.$t('incoming_card'), type: 2},
            { id: 2, text: this.$t('outgoing_card'), type: 2},
        ],
        recordTypeList: [
            { id: 1, text: this.$t('cheque')},
            { id: 2, text: this.$t('card')},
        ],
        descriptionTypeList: [],
        localCurrency: null,
        chequeForm: {
            id: null,
            bank_account_id: '-1', 
            transaction_date: moment(),
            due_date: moment(),
            transaction_number: null,
            currency: '-1',
            amount: 0.00,
            rate: 1,
            cheque_number: null,
            description: null,
            amount_local: 0.00
        },
        form: {
            docket_type: 10,
            record_date: moment(),
            docket_number: null, 
            account_name: '-1',
            account_id: '-1',
            transaction_type: 1,
            record_type: 1,
            is_accounted: 0,
            payment_account_type: 1,
            payment_account_id: '-1',
            payment_account_name: null,
            average_due_state: 0
        }, 
        modalType: 'addItem',
        chequeSummaryList: [],
        isDocketSaving: false,
        isContactInfoVisible: false,
        isDocketItemSaving: false,
        isModalButtonDisabled: false,
        menuSelection: '/ChequeTransactionHelppage',
        iconView : false,
        isSaving: false,
        isViewStatementModal: false,
        balanceClosingList: [],
        dueSummary: {
            total_average_due_state: 0,
            total_average_due_date: null
        },
        isSearchingAccount: false,
        isManualBalanceClosing: false,
        isBalanceClosed: false,
        isLocalAmountDisabled:true
    };
  },
  computed: {
    setColumnTemplateForLocal(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);          
        }
   },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
   isItemButtonDisabled() {
       return this.chequeItemsList.find(item =>item.isSelected == true );
    },
    showPageSizeSelector() {
        return this.chequeItemsList.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.chequeItemsList.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    },
    transactionTypeFilteredList() {
        return this.transactionTypeList.filter(p => { 
            return p.type == this.form.record_type;
        });
    },
    isBalanceClosingActive() {
        return this.form.payment_account_id !== null && this.form.payment_account_id !== '-1' && this.form.payment_account_id !== '' && this.chequeForm.bank_account_id !== null 
        && this.chequeForm.bank_account_id !== '-1' && this.chequeForm.bank_account_id !== '';
    },
    getSubCredentials() {
      return (operation)=>{
        let isView = false;
        if(this.form.record_type == 1 && this.form.transaction_type == 1) isView = this.$isCredentialActive(40, operation, 38);
        if(this.form.record_type == 1 && this.form.transaction_type == 2) isView = this.$isCredentialActive(41, operation, 38);
        if(this.form.record_type == 2 && this.form.transaction_type == 1) isView = this.$isCredentialActive(42, operation, 38);
        if(this.form.record_type == 2 && this.form.transaction_type == 2) isView = this.$isCredentialActive(43, operation, 38);
        return isView;
      }
    }
  },
  methods: {
    getData() { 
        this.$Progress.start();
        this.isPrintModalOpen = false;
         const parameters = {
            session_id: this.$getUser().session_id,
            list_name: ["currency"],
            list_type: 2, // Bank List: 2
            get_access_status: 0
        }; 
        const parametersTwo = { 
            session_id: this.$getUser().session_id,
            docket_header_id: this.$getSessionStorage('record_id')
        };
        const parametersThree = {
            session_id: this.$getUser().session_id,
            account_type: 4, // Bank: 4
        }; 
        const that = this;
        const requestOne =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Helper/GetLists', parameters, {'Content-Type': 'application/json'}); 
        const requestThree =  axios.post('/api/Currency/GetList', parameters, {'Content-Type': 'application/json'}); 
        const requestFour =  axios.post('/api/Cheque/GetChequeById', parametersTwo, {'Content-Type': 'application/json'}); 
        const requestFive =  axios.post('/api/CompanyAccounts/GetAccounts', parametersThree, {'Content-Type': 'application/json'}); 
        axios.all([requestOne, requestTwo, requestThree, requestFour, requestFive]).then(axios.spread((...responses) => {
            this.currencyList = responses[0].data.currency;
            this.localCurrency = this.$getUser().currency_code; 
            if (this.localCurrency !== null && this.localCurrency !== '' && this.localCurrency !== undefined) {
                this.chequeForm.currency = this.$getUser().currency_code;
            } 
            this.bankList = responses[1].data;
            this.bankList.unshift({ id: '-1', text: this.$t('select_an_option')}); 
            this.currencyList = responses[2].data;
            
            if(responses[3].data.cheque_items.length > 0){
                this.$setSessionStorage('tmp_session_id', responses[3].data.cheque_items[0].session_id); 
            }
            this.form = responses[3].data.cheque_header_detail;            
            this.form.transaction_type = responses[3].data.cheque_header_detail.docket_sub_type,
            this.chequeItemsList = responses[3].data.cheque_items;
            this.chequeSummaryList = responses[3].data.cheque_summary; 
            this.dueSummary = responses[3].data.due_summary; 
            this.isBalanceClosed = responses[3].data.is_balance_closing_exist;
            
            this.bankAccountList = responses[4].data.account_data;
            this.bankAccountList.forEach(element => {
                element.name = this.$unlock(element.name);
                element.account_id = this.$unlock(element.account_id);
                element.text = this.$unlock(element.text);
            });

            this.bankAccountList.unshift({ id: '-1', text: this.$t('select_an_option')});
            this.getDescriptions(function() {});
            this.$setSessionStorage('refreshList', true);
            this.$Progress.finish();
        }))
        .catch(errors => { 
            console.error(errors); 
            that.$Progress.finish();
        });
    },
    handlePropertyChange(e) {
        if(e.name == "paging") {
            this.pageIndex = e.component.pageIndex();
        }
    },
    openItemModal(modalMode) {
        const parameters = {
            route: modalMode == 'addItem'  ? 'ChequeTransactionItemCreate' : 'ChequeTransactionItemUpdate',
            session_id: this.$getUser().session_id
        };  
        axios.post('/api/FormValidations/GetFormFields', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                sessionStorage.setItem('frm_val', JSON.stringify(response.data));
            }
            this.modalType = modalMode;
            this.isContactInfoVisible = false;
            this.isDocketItemSaving = false;
            this.isModalButtonDisabled = false;
            this.isOpenDescriptionDropdown = false;
            this.isTabChangedBefore = false;
            this.activeTab = 'Transaction';
            this.isManualBalanceClosing = false;
            this.isLocalAmountDisabled = true;

            // Doğru listeleri getirebilmek için Edit mode durumunda Account Tipi önden alınır.
            if(modalMode == 'editItem'){
                this.chequeItemsList.forEach((item) => { 
                    if(item.isSelected){
                        this.fileUUID = item.file_id == null ? uuid.v4() : item.file_id;
                    }
                });
            }
            else { this.fileUUID = uuid.v4(); } 

            // Form öğeleri sıfırlanır.
            this.chequeForm.id = null;
            this.chequeForm.bank_account_id = '-1'; 
            this.chequeForm.transaction_number = null; 
            this.chequeForm.amount = 0.00;
            this.chequeForm.amount_local = 0.00;
            this.chequeForm.rate = 1;
            this.chequeForm.cheque_number = null;
            this.chequeForm.description = null;
            this.chequeForm.currency = this.localCurrency;
            this.chequeForm.due_date = moment(this.form.record_date);
            this.chequeForm.transaction_date = moment(this.form.record_date);
            this.balanceClosingList = [];
            if(this.form.payment_account_type == 1 || this.form.payment_account_type == 2) { 
                this.$refs.BalanceClosingList.form = {
                    account_id: this.form.payment_account_id,
                    id: this.chequeForm.id,
                    amount: Math.abs(parseFloat(this.chequeForm.amount)),
                    item_type: this.form.transaction_type,
                    docket_type: 10
                };
                this.$refs.BalanceClosingList.getData();
            }
            // Open Docket Modal in Edit Mode.
            if(this.modalType == 'editItem'){ 
                this.chequeItemsList.forEach((item) => { 
                    if(item.isSelected){ 
                        this.chequeForm.id = item.id; 
                        this.chequeForm.bank_account_id = item.bank_account_id;  
                        this.chequeForm.transaction_number = item.transaction_number; 
                        this.chequeForm.amount = item.amount.replace(/,/g, '');
                        this.chequeForm.amount_local = item.amount_local.replace(/,/g, '');
                        this.chequeForm.rate = item.rate.replace(/,/g, '');
                        this.chequeForm.cheque_number = item.cheque_number;
                        this.chequeForm.description = item.description;
                        this.chequeForm.transaction_date = moment(item.transaction_date); 
                        this.chequeForm.due_date = moment(item.due_date); 
                        this.chequeForm.currency = item.currency; 
                    }
                });
            }
            this.onChangeCurrency(true);
        });
    },
    onSelectItem(item) {
        this.chequeItemsList.forEach((value) => { 
            if (item.id !== value.id) {
                value.isSelected = false;
            }
        });
    },
    onChangeAmount() {
        if(this.form.payment_account_id == null || this.form.payment_account_id == '' || this.form.payment_account_id == '-1' || this.form.payment_account_id == undefined) return;
        const parameters = {
          session_id: this.$getUser().session_id,
          account_id: this.form.payment_account_id
        };  
        axios.post('/api/CompanyAccounts/GetAccountBalance', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.chequeForm.amount = this.chequeForm.currency !== this.localCurrency ? Math.abs(parseFloat(response.data.total_balance.replaceAll(',', ''))) : Math.abs(parseFloat(response.data.total_balance_local.replaceAll(',', '')));
                this.calculateLocalAmount(function() {});
            }
        })
        .catch((error) => {
           console.error(error);
        });
    },
    onChangeRateType(){
        const params = {
            session_id: this.$getUser().session_id,
            rate_date: moment(this.chequeForm.transaction_date),
            bank_id: 1, //EUROPEAN BANK
            currency: this.chequeForm.currency
        };
        params.rate_date = moment(params.rate_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        var source = this.typeList.find((element) => element.id == this.typeSelection);
        params.bank_id = source.type; // 1: European Bank 2: HMRC 3: Live Rate
        axios.post('/api/Rate/GetRates', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.length > 0){
                this.rateList = response.data;
                this.form.rate_list_id = response.data[0].id;
                this.chequeForm.rate = parseFloat(response.data[0].rate.replace(',', '.'));
                this.chequeForm.rate_date = response.data[0].rate_date;
                this.calculateLocalAmount(function() {});
            }
            else{
                this.chequeForm.rate = 1;
                this.chequeForm.rate_date = null;
                this.rateList = null;
                this.calculateLocalAmount(function() {});
            }
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error);
            this.$Progress.finish();
        });  
    },
    onChangeCurrency(noWriteRate) {
        let originalRate = this.chequeForm.rate;
        this.chequeForm.rate = 1; 
        if(this.chequeForm.currency !== this.localCurrency){

            axios.post('/api/Rate/RateTypes', { session_id: this.$getUser().session_id }, {'Content-Type': 'application/json'})
                .then((typeResponse) => {
                        this.typeList = typeResponse.data;
                        this.typeList.forEach((item) => { 
                            if(item.is_default == 1){
                                this.typeSelection = item.id;
                            }
                        });  

                        this.$Progress.start();
                        const params = {
                                session_id: this.$getUser().session_id,
                                rate_date: moment(this.chequeForm.transaction_date),
                                bank_id: 1, //EUROPEAN BANK
                                currency: this.chequeForm.currency
                        };
                        params.rate_date = moment(params.rate_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
                        var source = this.typeList.find((element) => element.id == this.typeSelection);
                        params.bank_id = source.type; // 1: European Bank 2: HMRC 3: Live Rate
                        axios.post('/api/Rate/GetRates', params, {'Content-Type': 'application/json'})
                        .then((response) => {
                            if(response.data.length > 0){
                                this.rateList = response.data;
                                this.form.rate_list_id = response.data[0].id;
                                this.chequeForm.rate = parseFloat(response.data[0].rate.replace(',', '.'));
                                this.chequeForm.rate_date = response.data[0].rate_date;
                                this.calculateLocalAmount(function() {});
                            }
                            else{
                                this.chequeForm.rate = 1;
                                this.chequeForm.rate_date = null;
                                this.calculateLocalAmount(function() {});
                            }
                            
                            if(noWriteRate){
                                this.chequeForm.rate = originalRate;
                                this.calculateLocalAmount(function() {});
                            }
                            this.$Progress.finish();
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$Progress.finish();
                        });  

                })
                .catch((error) => {
                    console.error(error); 
                }); 
        }
    },
    addChequeItem(){
        this.$checkSelect2Validation('chequeItemForm');
        if(!document.forms['chequeItemForm'].reportValidity()){
            return;
        }
        this.isModalButtonDisabled = true;
        this.isDocketItemSaving = true;
        const that = this;
        if (this.chequeForm.rate == null || this.chequeForm.rate == '' || this.chequeForm.rate == undefined) { this.chequeForm.rate = 0; }
        if (this.chequeForm.amount == null || this.chequeForm.amount == '' || this.chequeForm.amount == undefined) { this.chequeForm.amount = 0; }
        const params = { 
            item_type: this.form.transaction_type,
            bank_account_id: this.chequeForm.bank_account_id, 
            transaction_date: this.chequeForm.transaction_date,
            transaction_number: this.chequeForm.transaction_number,
            currency: this.chequeForm.currency,
            amount: this.chequeForm.amount,
            rate: this.chequeForm.rate,
            cheque_number: this.chequeForm.cheque_number,
            description: this.chequeForm.description,
            session_id: this.$getUser().session_id,
            tmp_session_id: this.$getSessionStorage('tmp_session_id'),
            payment_account_id: this.form.payment_account_id,
            file_id: this.fileUUID,
            due_date: moment(this.chequeForm.due_date),
            isManualBalanceClosing: this.isManualBalanceClosing,
            isBcCrd: this.$isCredentialActive(26,'')
        };
        params.transaction_date = moment(params.transaction_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        params.file_id = params.file_id == '' ? params.file_id = null :  params.file_id;
        params.due_date = moment(params.due_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        let selectedBalances = [];
        this.balanceClosingList.forEach((value) => {
            if(value.isSelected && value.closing_amount_input > 0){
                selectedBalances.push({
                    balance_id: value.id,
                    amount: value.closing_amount_input
                });
            }
        });
        params.balanceList = selectedBalances;
        axios.post('api/Cheque/CreateChequeItem', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
               if(response.data.cheque_items.length > 0){
                    this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id); 
                    this.chequeItemsList = response.data.cheque_items;
                    this.chequeSummaryList = response.data.cheque_summary;
                    this.dueSummary = response.data.due_summary;
                    this.isBalanceClosed = response.data.is_balance_closed;
                    this.$refs.closeModal.click();
                }  
            } 
            this.isDocketItemSaving = false;
        })
        .catch(() => {
            this.isDocketItemSaving = false;
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");
        })
        .finally(() => { 
            setTimeout(() => {
                that.isDocketItemSaving = false;
                that.isModalButtonDisabled = false;
            }, 500);
        });   
    },
    editChequeItem(){
        this.$checkSelect2Validation('chequeItemForm');
        if(!document.forms['chequeItemForm'].reportValidity()){
            return;
        }
        this.isModalButtonDisabled = true;
        this.isDocketItemSaving = true;
        const that = this;
        if (this.chequeForm.rate == null || this.chequeForm.rate == '' || this.chequeForm.rate == undefined) { this.chequeForm.rate = 0; }
        if (this.chequeForm.amount == null || this.chequeForm.amount == '' || this.chequeForm.amount == undefined) { this.chequeForm.amount = 0; }
        const params = { 
            id: this.chequeForm.id,
            item_type: this.form.transaction_type,
            bank_account_id: this.chequeForm.bank_account_id, 
            transaction_date: this.chequeForm.transaction_date,
            transaction_number: this.chequeForm.transaction_number,
            currency: this.chequeForm.currency,
            amount: this.chequeForm.amount,
            rate: this.chequeForm.rate,
            cheque_number: this.chequeForm.cheque_number,
            description: this.chequeForm.description,
            session_id: this.$getUser().session_id,
            tmp_session_id: this.$getSessionStorage('tmp_session_id'),
            payment_account_id: this.form.payment_account_id,
            due_date: this.chequeForm.due_date,
            file_id: this.fileUUID,
            isManualBalanceClosing: this.isManualBalanceClosing,
            isBcCrd: this.$isCredentialActive(26,'')
        };
        params.transaction_date = moment(params.transaction_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        params.due_date = moment(params.due_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
        params.file_id = params.file_id == '' ? params.file_id = null :  params.file_id;
        let selectedBalances = [];
        this.balanceClosingList.forEach((value) => {
            if(value.isSelected && value.closing_amount_input > 0){
                selectedBalances.push({
                    balance_id: value.id,
                    amount: value.closing_amount_input
                });
            }
        });
        params.balanceList = selectedBalances;
        axios.post('api/Cheque/UpdateChequeItem', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                if(response.data.cheque_items.length > 0){
                    this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id);
                    this.chequeItemsList = response.data.cheque_items;
                    this.chequeSummaryList = response.data.cheque_summary;
                    this.dueSummary = response.data.due_summary;
                    this.isBalanceClosed = response.data.is_balance_closed;
                    this.$refs.closeModal.click();
                }  
            }   
            this.isDocketItemSaving = false;
        })
        .catch(() => {
            this.isDocketItemSaving = false;
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");
        })
        .finally(() => { 
            setTimeout(() => {
                that.isDocketItemSaving = false;
                that.isModalButtonDisabled = false;
            }, 500);
        });   
    },
    deleteChequeItem() {
         this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_remove_this_item'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) { 
                this.$Progress.start();
                var docketId = null; 
                this.chequeItemsList.forEach((item) => { 
                    if(item.isSelected){ 
                        docketId = item.id; 
                    }
                });
                const params = { 
                    id: docketId, 
                    session_id: this.$getUser().session_id,
                    tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                    docket_header_id: this.$getSessionStorage('record_id')
                };
                axios.post('api/Cheque/DeleteChequeItem', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                        if(response.data.cheque_items.length > 0){
                            this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id);  
                        }   
                        this.chequeItemsList = response.data.cheque_items;
                        this.chequeSummaryList = response.data.cheque_summary;
                        this.dueSummary = response.data.due_summary;
                        this.isBalanceClosed = false;
                    } 
                    this.$Progress.finish(); 
                })
                .catch(() => {
                    this.$Progress.finish();
                });  
            }
        }); 
    },
    deleteAllChequeItems() {
         this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_remove_all_items'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {  
                this.$Progress.start();
                const params = { 
                    session_id: this.$getUser().session_id,
                    tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                    docket_header_id: this.$getSessionStorage('record_id')
                };
                axios.post('api/Cheque/DeleteAllChequeItems', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                        this.$removeSessionStorage('tmp_session_id'); 
                        this.chequeItemsList = [];
                        this.chequeSummaryList = [];
                        this.dueSummary = [];
                        this.isBalanceClosed = false;
                        this.$refs.closeModal.click();
                    } 
                    this.$Progress.finish(); 
                })
                .catch(() => {
                    this.$Progress.finish();
                });  
            }
        }); 
    },
    updateChequeHeader(){
        this.$checkSelect2Validation('poliform');
        if(!document.forms['poliform'].reportValidity()){
            return;
        }
        this.isDocketSaving = false;
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_save_this_transaction'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('save'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                this.$Progress.start();
                this.isDocketSaving = true; 
                const that = this;
                const params = { 
                    id: this.$getSessionStorage('record_id'),
                    session_id: this.$getUser().session_id,
                    tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                    record_date: this.form.record_date
                };  
                params.record_date = moment(params.record_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
                axios.post('api/Cheque/UpdateChequeHeader', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                        this.$removeSessionStorage('tmp_session_id');
                        this.$setSessionStorage('refreshList', true); 
                        this.getData();
                        this.$swal(this.$t('success'), this.$t('transaction_updated_succesfully'), 'success');
                        this.isDocketSaving = false;
                        this.$Progress.finish();
                    } 
                    this.$Progress.finish(); 
                })
                .catch(() => { 
                    this.$Progress.finish(); 
                    this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
                })
                .finally(() => { 
                    setTimeout(() => {
                        that.isDocketSaving = false;
                        that.$Progress.finish(); 
                    }, 500);
                }); 
            }
        }); 
    },
    deleteChequeHeader(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_delete_this_transaction'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {  
                this.$Progress.start(); 
                const params = { 
                    id: this.$getSessionStorage('record_id'),
                    session_id: this.$getUser().session_id
                };  
                axios.post('api/Cheque/DeleteChequeHeader', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                        this.$setSessionStorage('refreshList', true);    
                        this.$router.push({ name: 'ChequeTransactionCreate' });
                    } 
                    this.$Progress.finish(); 
                })
                .catch(() => {
                    this.$Progress.finish();
                });  
            }
        });
    },
    getRowNumber(data) {
      return data.rowIndex + 1;
    },
    onChangeChequeAccount() {
        this.chequeForm.amount_local = 0.00;
        this.bankAccountList.forEach((item) => {
            if (item.id == '-1') {
                this.chequeForm.currency = this.localCurrency;
                this.chequeForm.rate = 1;
                this.chequeForm.rate_date = null;
                return;
            }
            if (item.id == this.chequeForm.bank_account_id) {
                if (item.bank_currency !== null && item.bank_currency !== '' && item.bank_currency !== undefined) {
                    this.chequeForm.currency = item.bank_currency;
                    this.onChangeCurrency();
                }
            }
        });
    },
    getCurrencies(){
        const params = {
            session_id: this.$getUser().session_id
        };    
        axios.post('/api/Currency/GetList', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.currencyList = response.data;
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    calculateLocalAmount(callback){
        if(this.$getUser().currency_search_type == 1) {
            this.chequeForm.amount_local = this.chequeForm.amount / this.chequeForm.rate;
        } else {
            this.chequeForm.amount_local = this.chequeForm.amount * this.chequeForm.rate;
        }
        this.isManualBalanceClosing = false;
        if(typeof callback == 'function'){
            callback();
        }
    },
    onChangeTransactionType() {
        this.chequeForm.bank_account_id = '-1'; 
        this.chequeForm.currency = this.localCurrency;
        this.chequeForm.rate = 1;
        this.chequeForm.rate_date = null;
        this.chequeForm.amount_local = parseFloat(this.chequeForm.amount) / parseFloat(this.chequeForm.rate);
        this.getDescriptions(function() {});
    },
    getAccountDetail(id) {
        this.form.payment_account_id = id;
        this.chequeForm.amount = 0.00;
        this.chequeForm.amount_local = 0.00;
        this.form.payment_account_name = null;
        if (id == '-1' || id == null || id == undefined) return;
        const params = {
            id: id,
            session_id: this.$getUser().session_id
        }; 
        axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.form.payment_account_name = this.$unlock(response.data.name);
            this.form.payment_account_type = response.data.account_type;
        });
    },
    setSummaries(options){
        if(options.name == "amount_local"){
            if(options.summaryProcess === 'start'){
                options.totalValue = 0;
            }
            else if(options.summaryProcess === 'calculate'){
                var amount_local = parseFloat(options.value.amount_local.replaceAll(',', ''));
                (options.totalValue += amount_local);
            }
            else if(options.summaryProcess === 'finalize'){ 
                options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
            }
        }
    },
    getDescriptions(callback) {
        this.isOpenDescriptionDropdown = false;
        if (this.modalType == 'addItem') { this.chequeForm.description = null; }
        const params = {
            session_id: this.$getUser().session_id,
            description_location: 6, // Cheque
            location_detail: this.form.transaction_type,
            account_type: this.form.payment_account_type !== '-1' ? this.form.payment_account_type : 0,
            sales_type: 0
        };
        axios.post('/api/Helper/GetDescriptionTypes', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.descriptionTypeList = response.data;
            this.descriptionTypeList.forEach(element => {
                if (element.type_id == 2 && this.modalType == 'addItem') {
                    this.chequeForm.description = element.description;
                }
            });
            if(typeof callback == 'function'){
                callback();
            }
        });
    },
    onSelectDescription(item) {
        this.chequeForm.description = item.description;
        this.isOpenDescriptionDropdown = false;
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {   
                    if(column.dataField == 'amount_local'){ 
                        column.caption = this.$t('local_amount');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                });  
            } 
        } 
    },
    onActivateDocumentsTab(){
        this.activeTab = 'Document';
        if(this.fileUUID == null || this.fileUUID == '' || this.fileUUID == undefined){
            this.fileUUID = uuid.v4();         
        }
    },
    printReceipt(){
        if(!this.getSubCredentials('P')) return;
        this.$refs.PrintModal.isPrintModalOpen = true;
        this.$refs.PrintModal.isFrameLoading = true;
        this.$refs.PrintModal.documentName = this.form.payment_account_name.substring(0, 10) + '-' + (this.form.record_type == 2 ? 'Card Transaction-' : 'Cheque Transaction-') + this.form.docket_number;
        this.$refs.PrintModal.getData();
    },
    downloadReceipt(){
        if(!this.getSubCredentials('P')) return;
        const parameters = {
            session_id: this.$getUser().session_id,
            category: 2, // Receipt
            receipt_type: 2 // Receipt Type : Cheque
        };
        axios.post('/api/Reports/GetControllerReportDesigns', parameters, {'Content-Type': 'application/json'}).then((responseReport) => { 
            this.designList = responseReport.data.report_designs;
            this.designSelection = responseReport.data.default_report_design;
            this.designList.forEach((item) => { 
                if(item.id == this.designSelection){
                    this.reportType = item.category;
                }
            });

            if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
            {
                fetch('https://localhost:5001/Home/Downloader?id=' + this.$getSessionStorage('record_id') + '&report_id='+ this.designSelection + "&report_type=" + this.reportType)
                    .then(response => response.blob())
                    .then(data => {
                        saveAs(data, (this.form.payment_account_name.substring(0, 10) + ' - ' + (this.form.record_type == 2 ? 'Card Transaction' : 'Cheque Transaction') + '-' + this.form.docket_number) + '.pdf');
                    });
            }
            else{
                fetch('/reports/Home/Downloader?id=' + this.$getSessionStorage('record_id') + '&report_id='+ this.designSelection + "&report_type=" + this.reportType)
                    .then(response => response.blob())
                    .then(data => {
                        saveAs(data, (this.form.payment_account_name.substring(0, 10) + ' - ' + (this.form.record_type == 2 ? 'Card Transaction' : 'Cheque Transaction') + '-' + this.form.docket_number) + '.pdf');
                    });
            } 
        })
        .catch((error) => {
            console.error(error); 
        });
    }, 
    onCancelIntegration() {
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_cancel_accounting_integration'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('confirm'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const params = {
                    session_id: this.$getUser().session_id,
                    header_id: this.$getSessionStorage('record_id')
                };
                axios.post('api/AccountingIntegration/CancelSingleIntegration', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.$swal(this.$t('success'), this.$t('accounting_integration_canceled'), 'success');  
                        this.getData();
                    }
                })
                .catch((error) => { 
                    console.error(error)
                });  
            }
        });
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/ChequeTransactionHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    onOpenTransactionListModal() {
        this.$refs.TransactionListModal.getData();
    },
    onClickBalanceClosing() {
        this.isManualBalanceClosing = true;
        let isAuto = this.modalType == 'addItem' ? true : false;
        this.$refs.BalanceClosingList.form = {
            account_id: this.form.payment_account_id,
            id: this.chequeForm.id,
            amount: Math.abs(parseFloat(this.chequeForm.amount)),
            item_type: this.form.transaction_type,
            docket_type: 10
        };
        if(this.form.transaction_type == 2){ this.$refs.BalanceClosingList.balanceForm.isShowAll = false; }
        this.$refs.BalanceClosingList.balanceForm.currency = this.chequeForm.currency;
        this.$refs.BalanceClosingList.onGetBalanceList(isAuto);
    },
    onOpenAccountReport(){
        this.$refs.AccountReports.getData();
        this.$refs.AccountReports.setModalCriteriasToDefault();
    },
    calculateAmountLocal(callback)
    {
        if(this.$getUser().currency_search_type == 1) {
            this.chequeForm.rate = this.chequeForm.amount_local * this.chequeForm.amount;
        } else {
            this.chequeForm.rate = this.chequeForm.amount_local / this.chequeForm.amount;
        }
        if(typeof callback == 'function'){
            callback();
        }
    },
    onChangeAmountLocal(){
        this.isLocalAmountDisabled = !this.isLocalAmountDisabled;
    }
  },
  created() {
    this.helpPageViewIcon();
    this.$setSessionStorage('refreshList', true);
    this.$setSessionStorage('report_category', 2); // Receipt
    this.$setSessionStorage('receipt_type', 2); // Cheque
    this.$removeSessionStorage('tmp_session_id'); 
    this.fileUUID = uuid.v4(); 
    this.getData();
  },
};
</script>